// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__vCbd6","leftCol":"styles_leftCol__idacZ","rightCol":"styles_rightCol__7otOD"};